/**
 * Build a Collection page logic.
 * Uses native Shopify Cart API via BundleManager.
 */
(function () {
  'use strict';

  // Track current cart so overlay qty controls can check remaining slots
  var currentCart = null;

  function getRemainingSlots() {
    var target = window.BundleManager.getTargetSize() || 0;
    var count = currentCart ? (currentCart.item_count || 0) : 0;
    return Math.max(target - count, 0);
  }

  function getUrlSize() {
    var params = new URLSearchParams(window.location.search);
    var size = parseInt(params.get('size'), 10);
    if (size === 5 || size === 10) return size;
    // No ?size= in the URL: respect the user's previous choice if any,
    // otherwise default first-time visitors to the 10-item bundle.
    var stored = window.BundleManager.getTargetSize();
    if (stored === 5 || stored === 10) return stored;
    return 10;
  }

  function initSize() {
    var size = getUrlSize();
    window.BundleManager.setTargetSize(size);
    updateToggleButtons(size);
  }

  function updateToggleButtons(size) {
    var btn5 = document.getElementById('toggle-5');
    var btn10 = document.getElementById('toggle-10');
    if (btn5) btn5.classList.toggle('btn--toggle-active', size === 5);
    if (btn10) btn10.classList.toggle('btn--toggle-active', size === 10);
  }

  // Render bundle slot boxes from real Shopify cart data
  function renderSlots(cart) {
    var grid = document.getElementById('bundle-slots-grid');
    var status = document.getElementById('bundle-status');
    var message = document.getElementById('bundle-message');
    var viewCartLink = document.getElementById('bundle-view-cart');
    var totalEl = document.getElementById('bundle-total');
    var targetSize = window.BundleManager.getTargetSize();

    if (!grid || !targetSize || !cart) return;

    // Expand line items by quantity so each unit fills its own slot
    var expanded = [];
    (cart.items || []).forEach(function (item) {
      for (var q = 0; q < item.quantity; q++) {
        expanded.push(item);
      }
    });

    var html = '';

    for (var i = 0; i < targetSize; i++) {
      var item = expanded[i];
      if (item) {
        var imgSrc = '';
        if (item.image) {
          imgSrc = item.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2');
        }
        html += '<div class="bundle-slot bundle-slot--filled" data-line-key="' + item.key + '">';
        html += '<img src="' + imgSrc + '" alt="' + item.title.replace(/"/g, '&quot;') + '" class="bundle-slot__image">';
        html += '<button type="button" class="bundle-slot__remove btn-remove-from-bundle" data-line-key="' + item.key + '" aria-label="Remove">&times;</button>';
        html += '</div>';
      } else {
        html += '<div class="bundle-slot bundle-slot--empty">';
        html += '<span class="bundle-slot__number">' + (i + 1) + '</span>';
        html += '</div>';
      }
    }
    grid.innerHTML = html;

    // Status
    var count = cart.item_count || 0;
    if (status) {
      status.textContent = count + ' / ' + targetSize;
    }

    // Message
    if (message) {
      if (count >= targetSize) {
        message.textContent = 'Bundle complete!';
        message.classList.add('bundle-slots__message--complete');
      } else {
        var remaining = targetSize - count;
        message.textContent = remaining + ' more to go';
        message.classList.remove('bundle-slots__message--complete');
      }
    }

    // Running total
    if (totalEl) {
      totalEl.textContent = window.BundleManager.formatMoney(cart.total_price || 0);
    }

    // View cart link (shown when complete)
    if (viewCartLink) {
      viewCartLink.style.display = window.BundleManager.canCheckout(cart) ? 'block' : 'none';
    }

    // Store cart reference and update add buttons
    currentCart = cart;
    var addButtons = document.querySelectorAll('.btn-add-to-bundle');
    var isFull = window.BundleManager.isFull(cart);
    addButtons.forEach(function (btn) {
      btn.disabled = isFull;
    });

    // Reset desktop overlay qty steppers to 1 (capped to remaining slots).
    var remaining = getRemainingSlots();
    document.querySelectorAll('.product-card__qty-value').forEach(function (el) {
      el.textContent = remaining > 0 ? '1' : '0';
    });
  }

  // Combined search + category-filter pipeline
  function getActiveFilter() {
    var select = document.getElementById('product-filter');
    return select ? (select.value || 'all') : 'all';
  }

  function applyFilters() {
    var input = document.getElementById('product-search');
    var noResults = document.getElementById('no-results');
    var query = input ? input.value.toLowerCase().trim() : '';
    var filter = getActiveFilter();
    var cards = document.querySelectorAll('.product-card');
    var visibleCount = 0;

    cards.forEach(function (card) {
      // Same field the search uses: title + product_type + vendor + tags, all
      // joined and lowercased. Substring match keeps filter behaviour in sync
      // with the search bar (e.g. matches "tinned-fish" tag or "Tinned Fish"
      // in the title alike).
      var searchable = card.getAttribute('data-searchable') || '';

      var matchesSearch = !query || searchable.indexOf(query) !== -1;
      var matchesFilter = filter === 'all' || searchable.indexOf(filter) !== -1;

      var visible = matchesSearch && matchesFilter;
      card.style.display = visible ? '' : 'none';
      if (visible) visibleCount++;
    });

    if (noResults) {
      noResults.style.display = visibleCount === 0 ? 'block' : 'none';
    }
  }

  function initSearch() {
    var input = document.getElementById('product-search');
    if (!input) return;
    input.addEventListener('input', applyFilters);
  }

  function initFilters() {
    var select = document.getElementById('product-filter');
    if (!select) return;
    select.addEventListener('change', applyFilters);
  }

  // Event delegation for cart icon (mobile), overlay qty/add (desktop),
  // and bundle slot remove
  function initButtons() {
    document.addEventListener('click', function (e) {
      // Desktop overlay: qty + (capped to remaining slots)
      var qtyPlus = e.target.closest('.product-card__qty-plus');
      if (qtyPlus) {
        e.preventDefault();
        var valEl = qtyPlus.parentElement.querySelector('.product-card__qty-value');
        var current = parseInt(valEl.textContent, 10) || 1;
        var remainingPlus = getRemainingSlots();
        if (current < remainingPlus) {
          valEl.textContent = current + 1;
        }
        return;
      }

      // Desktop overlay: qty −
      var qtyMinus = e.target.closest('.product-card__qty-minus');
      if (qtyMinus) {
        e.preventDefault();
        var valEl2 = qtyMinus.parentElement.querySelector('.product-card__qty-value');
        var currentMinus = parseInt(valEl2.textContent, 10) || 1;
        if (currentMinus > 1) valEl2.textContent = currentMinus - 1;
        return;
      }

      // Add-to-bundle: handles both the mobile cart icon AND the desktop
      // overlay "Add" button. They share the same .btn-add-to-bundle hook;
      // we differentiate by whether a qty stepper sits inside the same card.
      var addBtn = e.target.closest('.btn-add-to-bundle');
      if (addBtn) {
        // Stop the click from also navigating the surrounding link
        e.preventDefault();
        e.stopPropagation();
        if (addBtn.disabled) return;
        if (addBtn.closest('.product-card--sold-out')) return;
        var remaining = getRemainingSlots();
        if (remaining <= 0) return;

        // Cart icon (mobile) → always add 1.
        // Overlay Add button (desktop) → read qty from the card's stepper.
        var qty = 1;
        if (addBtn.classList.contains('product-card__add-btn')) {
          var card = addBtn.closest('.product-card');
          var qtyVal = card ? card.querySelector('.product-card__qty-value') : null;
          qty = qtyVal ? parseInt(qtyVal.textContent, 10) || 1 : 1;
          if (qty > remaining) qty = remaining;
        }

        addBtn.disabled = true;
        window.BundleManager.addItem(addBtn.dataset.variantId, qty)
          .catch(function () {
            addBtn.disabled = false;
          });
        return;
      }

      // Remove from bundle via Cart API (decrement by 1, not full removal)
      var removeBtn = e.target.closest('.btn-remove-from-bundle');
      if (removeBtn) {
        e.preventDefault();
        var lineKey = removeBtn.dataset.lineKey;
        if (lineKey) {
          window.BundleManager.getCart().then(function (cart) {
            var lineItem = null;
            (cart.items || []).forEach(function (it) {
              if (it.key === lineKey) lineItem = it;
            });
            if (lineItem && lineItem.quantity > 1) {
              window.BundleManager.updateItem(lineKey, lineItem.quantity - 1);
            } else {
              window.BundleManager.removeItem(lineKey);
            }
          });
        }
        return;
      }
    });
  }

  // Toggle buttons
  function initToggle() {
    var btn5 = document.getElementById('toggle-5');
    var btn10 = document.getElementById('toggle-10');

    function handleToggle(e, size) {
      e.preventDefault();
      window.BundleManager.setTargetSize(size);
      updateToggleButtons(size);
      var url = new URL(window.location);
      url.searchParams.set('size', size);
      history.replaceState(null, '', url);
    }

    if (btn5) btn5.addEventListener('click', function (e) { handleToggle(e, 5); });
    if (btn10) btn10.addEventListener('click', function (e) { handleToggle(e, 10); });
  }

  // Loading state: lock all product card interactions while cart API is in-flight
  document.addEventListener('cart:loading', function (e) {
    var slotsEl = document.getElementById('bundle-slots');
    if (slotsEl) {
      slotsEl.classList.toggle('is-loading', e.detail === true);
    }
    var grid = document.querySelector('.build-collection__grid');
    if (grid) {
      grid.classList.toggle('is-loading', e.detail === true);
    }
  });

  // Listen for cart updates
  document.addEventListener('cart:updated', function (e) {
    renderSlots(e.detail);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initSize();
    initSearch();
    initFilters();
    initButtons();
    initToggle();
    // Initial render from cart
    window.BundleManager.getCart().then(renderSlots);
  });
})();
